import { ReactComponent as UaFlag } from "@assets/images/icons/ua-lang.svg";
import { ReactComponent as EnFlag } from "@assets/images/icons/en-lang.svg";
import { ReactComponent as RuFlag } from "@assets/images/icons/ru-lang.svg";
import { ReactComponent as EsFlag } from "@assets/images/icons/es-lang.svg";

/** Мови інтерфейсу. `code` — код локалі в застосунку й на беку (не міняти),
 *  `shortLabel` — ISO-код мови для відображення, `name` — назва рідною мовою. */
export const LANGUAGES = [
  { code: "en", shortLabel: "EN", name: "English", Flag: EnFlag },
  { code: "ru", shortLabel: "RU", name: "Русский", Flag: RuFlag },
  { code: "es", shortLabel: "ES", name: "Español", Flag: EsFlag },
  { code: "ua", shortLabel: "UK", name: "Українська", Flag: UaFlag },
];

export const getLanguage = (code) =>
  LANGUAGES.find((language) => language.code === code) || LANGUAGES[0];
